import * as Types from 'src/actions/authentication/password-reset/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import Token from 'src/value-objects/Token';
import { AxiosResponse } from 'axios';
import ValidatorService from 'src/services/validation/Validation.service';

export interface PasswordResetClearErrors extends Action {
  type: Types.PASSWORD_RESET_CLEAR_ERRORS;
}

export const passwordResetClearErrors: ActionCreator<PasswordResetClearErrors> = () => (
  { type: Types.PASSWORD_RESET_CLEAR_ERRORS }
);

export interface PasswordResetAttempt extends Action {
  type: Types.PASSWORD_RESET_ATTEMPT;
}

export interface PasswordResetSuccess extends Action {
  type: Types.PASSWORD_RESET_SUCCESS;
  payload: Token;
}

export interface PasswordResetFailure extends Action {
  type: Types.PASSWORD_RESET_FAILURE;
  payload: {};
}

export type PasswordResetAction = PasswordResetAttempt |
  PasswordResetSuccess |
  PasswordResetFailure |
  PasswordResetClearErrors;

export interface PasswordResetThunk extends ThunkAction<Promise<PasswordResetAction>, RootState, null> {
}

export const passwordResetAttempt: ActionCreator<PasswordResetAttempt> = () => (
  { type: Types.PASSWORD_RESET_ATTEMPT }
);

export const passwordResetSuccess: ActionCreator<PasswordResetSuccess> = (token: Token) => (
  {
    type: Types.PASSWORD_RESET_SUCCESS,
    payload: token
  }
);

export const passwordResetFailure: ActionCreator<PasswordResetFailure> = (error: {}) => (
  {
    type: Types.PASSWORD_RESET_FAILURE,
    payload: error

  }
);

export const passwordReset: ActionCreator<PasswordResetThunk> = (
  credentials: {}
): PasswordResetThunk => {

  return (dispatch: Dispatch<RootState>): Promise<PasswordResetAction> => {
    dispatch(passwordResetAttempt());

    return ApiClient.passwordReset.create(credentials)
      .then((response: AxiosResponse<{}>): PasswordResetSuccess => {

        return dispatch(passwordResetSuccess());
      }).catch((response: AxiosResponse<{}>): PasswordResetFailure => {
        const errors = ValidatorService.translateValidations(JSON.parse(response.request.response).errors);
        return dispatch(passwordResetFailure(errors));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/authentication/password-reset/PasswordReset.actions.tsx